import { render } from "./UserForgotPassword.vue?vue&type=template&id=6e5053f6&ts=true"
import script from "./UserForgotPassword.vue?vue&type=script&lang=ts"
export * from "./UserForgotPassword.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__